import React from 'react';

import Parent from './review/parent.js';
import Gatekeeper from './gatekeeper.js';
import './review.css';

export default ({user, endpoints, match}) => (
  <Parent
    user={user}
    endpoints={endpoints}
    gatekeeper={new Gatekeeper(user, endpoints, match.params.orderId)}
    match={match}
  />
);



// WEBPACK FOOTER //
// ./src/app/reviews/new/review.js